import React from "react";

interface FileCategorySelectProps {
  value: string;
  onChange: (category: string) => void;
}

const CATEGORIES = [
  { value: "offer_attachment", label: "Załącznik do oferty" },
  { value: "brand_asset", label: "Materiał brandowy" },
  { value: "other", label: "Inne" },
];

const FileCategorySelect: React.FC<FileCategorySelectProps> = ({
  value,
  onChange,
}) => {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500"
    >
      {CATEGORIES.map((category) => (
        <option key={category.value} value={category.value}>
          {category.label}
        </option>
      ))}
    </select>
  );
};

export default FileCategorySelect;
